import { createWithI18n } from '@post-office/message-maker-browser/i18n';

import { messagesLoader as growth } from '@post-office/team-package--i18n--growth';
import { messagesLoader as ccFlywheelEngagement } from '@post-office/team-package--i18n--cc-flywheel-engagement';
import { messagesLoader as growthStarburst } from '@post-office/team-package--i18n--growth-starburst';
import { messagesLoader as postOfficeTeam } from '@post-office/team-package--i18n--post-office-team';
import { messagesLoader as ccFlywheelFeatureDiscovery } from '@post-office/team-package--i18n--cc-flywheel-feature-discovery';
import { messagesLoader as rovoExpansion } from '@post-office/team-package--i18n--rovo-expansion';
import { messagesLoader as belugas } from '@post-office/team-package--i18n--belugas';
import { messagesLoader as ccFlywheelActivation } from '@post-office/team-package--i18n--cc-flywheel-activation';
import { messagesLoader as ccMigrationsTooling } from '@post-office/team-package--i18n--cc-migrations-tooling';
import { messagesLoader as growthTransmuters } from '@post-office/team-package--i18n--growth-transmuters';
import { type AnyProps } from '@post-office/message-maker-browser/types';
import { type ComponentType } from 'react';

export const withI18n: <T extends AnyProps>(component: ComponentType<T>) => ComponentType<T> =
	createWithI18n(
		growth,
		ccFlywheelEngagement,
		growthStarburst,
		postOfficeTeam,
		ccFlywheelFeatureDiscovery,
		rovoExpansion,
		belugas,
		ccFlywheelActivation,
		ccMigrationsTooling,
		growthTransmuters,
	);
